<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M6.33105 6.49365C5.9709 6.89251 5.7501 7.41983 5.75 7.99951C5.75 9.24208 6.75745 10.2494 8 10.2495C8.53112 10.2494 9.0184 10.0642 9.40332 9.75635L12.1045 12.6265C9.34247 14.632 5.44307 14.3703 2.98047 11.8374L1.28223 10.0913C0.150608 8.92705 0.150653 7.07298 1.28223 5.90869L2.98047 4.16162C3.17852 3.95793 3.38723 3.77053 3.60254 3.59619L6.33105 6.49365ZM4.88672 2.771C7.53287 1.45727 10.8388 1.91996 13.0186 4.16162L14.7168 5.90869C15.8484 7.07305 15.8486 8.92708 14.7168 10.0913L13.2236 11.6255L10.208 8.42334C10.2342 8.28606 10.25 8.14442 10.25 7.99951C10.2498 6.75722 9.24228 5.74977 8 5.74951C7.90165 5.74952 7.80498 5.75777 7.70996 5.77002L4.88672 2.771Z"
    fill="currentColor"
  />
  <path
    d="M4.57535 1.42466L14.6747 12.1809"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
</svg>
